import { Amount } from '@root/api/ump-ewallet'

export const getSteamAccountFinalAmount = (baseAmount: number): Required<Pick<Amount, 'base' | 'fee' | 'total'>> => ({
  base: String(baseAmount),
  total: String(baseAmount + Number('50')),
  fee: '50',
})
